// Components
import RegisterPage from '../../features/Welcome/Register';

const Register = () => {
  return <RegisterPage />;
};

export default Register;